export const SEARCH_INSTRUCTIONS = 'Er moet op minimaal 2 karakters gezocht worden.'
export const NO_SEARCH_RESULTS = 'Geen resultaten.'
